import React from 'react'
import PropTypes from 'prop-types'
import BackLink from 'components/BackLink'
import SiteSelector from 'components/SiteSelector'

import { SiteSelectorK8WrapperDark } from './component.styles'

export const LessonBreadcrumbs = ({ goToDashboard }) => (
  <nav className="breadcrumbs">
    <BackLink onClick={goToDashboard}>My Programs</BackLink>
    <SiteSelectorK8WrapperDark>
      <SiteSelector />
    </SiteSelectorK8WrapperDark>
  </nav>
)

LessonBreadcrumbs.propTypes = {
  goToDashboard: PropTypes.func.isRequired,
}
